import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOMeta from '@/components/base/SEOMeta';
import StructuredData from '@/components/base/StructuredData';

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于黑料大全',
    description: '黑料大全是全网热门黑料汇总平台，致力于为吃瓜群众提供最新、最全的爆料信息。',
    url: 'https://heiliao.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料大全',
      url: 'https://heiliao.com',
    },
    about: {
      '@type': 'Organization',
      name: '黑料大全',
      description: '全网热门黑料汇总平台，涵盖娱乐圈、网红、明星等各类爆料信息。',
      foundingDate: '2024',
      url: 'https://heiliao.com',
    },
  };

  return (
    <>
      <SEOMeta
        title="关于我们 - 黑料大全"
        description="黑料大全是全网热门黑料汇总平台，致力于为吃瓜群众提供最新、最全面的娱乐圈、网红、明星爆料信息。了解我们的品牌故事、口碑声誉和联系方式。"
        keywords="黑料大全,关于黑料大全,黑料平台介绍,吃瓜平台,联系我们"
        canonicalUrl="https://heiliao.com/about"
        ogImage="https://readdy.ai/api/search-image?query=About%20us%20page%20for%20Chinese%20gossip%20news%20website%2C%20professional%20dark%20red%20theme%2C%20newsroom%20aesthetic%2C%20corporate%20media%20identity&width=1200&height=630&seq=about-og&orientation=landscape"
        ogImageAlt="关于黑料大全"
      />
      <StructuredData data={aboutSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

          {/* Hero */}
          <section className="w-full max-w-5xl mx-auto px-4 md:px-6 py-12 md:py-16">
            <div className="text-center max-w-3xl mx-auto">
              <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-500 mb-6">
                <i className="ri-fire-fill text-background-50 text-3xl"></i>
              </span>
              <h1 className="text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4 font-heading">
                关于 <span className="text-primary-500">黑料大全</span>
              </h1>
              <p className="text-lg text-foreground-600 leading-relaxed">
                全网热门黑料汇总平台，收录最新、最全的热门黑料内容，涵盖娱乐圈、网红、明星等各类爆料信息，是吃瓜群众的必备参考平台。
              </p>
            </div>
          </section>

          {/* Brand Story */}
          <section className="w-full bg-background-100 py-14 md:py-20">
            <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-5 font-heading">
                    品牌故事
                  </h2>
                  <div className="space-y-4 text-foreground-700 leading-relaxed">
                    <p>
                      黑料大全创立于2024年，是国内领先的娱乐爆料信息聚合平台。我们的创始团队由资深媒体人和互联网从业者组成，怀着"让信息更透明"的初心，打造了这个专注于娱乐圈、网红、明星等领域的热门爆料内容汇总网站。
                    </p>
                    <p>
                      在信息碎片化的时代，吃瓜群众往往需要在多个平台之间来回切换才能获取完整的爆料信息。黑料大全的诞生，正是为了解决这一痛点 —— 我们将散落在全网各处的黑料内容进行搜集、整理和呈现，让用户在一个平台上就能掌握最新、最全的热点动态。
                    </p>
                    <p>
                      我们秉持<strong>客观、真实、及时</strong>的原则，致力于为用户提供高质量的爆料内容。每一篇内容都经过编辑团队的审核整理，确保信息准确可靠。
                    </p>
                  </div>
                </div>
                <div className="rounded-xl overflow-hidden h-[350px] bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20office%20with%20journalists%20working%20on%20computers%2C%20dark%20red%20and%20black%20branding%2C%20professional%20media%20company%20environment%2C%20warm%20lighting%2C%20editorial%20team%20atmosphere&width=800&height=600&seq=about-brand&orientation=landscape"
                    alt="黑料大全品牌故事"
                    title="黑料大全 - 品牌故事"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="w-full max-w-5xl mx-auto px-4 md:px-6 py-14 md:py-20">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center font-heading">
              口碑声誉
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: '信息可靠',
                  desc: '每条爆料均标注来源，对未经证实的信息明确标注，让用户理性吃瓜。',
                },
                {
                  icon: 'ri-flashlight-line',
                  title: '更新及时',
                  desc: '7×24小时追踪全网热点，第一时间为用户推送最新爆料内容。',
                },
                {
                  icon: 'ri-group-line',
                  title: '千万用户信赖',
                  desc: '日均活跃用户超百万，已成为国内最具影响力的吃瓜平台之一。',
                },
                {
                  icon: 'ri-eye-line',
                  title: '内容全面',
                  desc: '涵盖娱乐圈、网红、明星、电竞、社会热点等多个领域，一网打尽。',
                },
                {
                  icon: 'ri-thumb-up-line',
                  title: '用户好评',
                  desc: '在各大应用商店和社交平台获得用户高度评价，口碑持续领先。',
                },
                {
                  icon: 'ri-shield-star-line',
                  title: '隐私保护',
                  desc: '重视用户隐私保护，浏览记录全程加密，让您放心吃瓜。',
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all"
                >
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 mb-4">
                    <i className={`${item.icon} text-primary-600 text-xl`}></i>
                  </span>
                  <h3 className="text-base font-bold text-foreground-950 mb-2 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Stats */}
          <section className="w-full bg-accent-500 py-14 md:py-20">
            <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                {[
                  { value: '1200万+', label: '月活跃用户' },
                  { value: '5万+', label: '累计爆料文章' },
                  { value: '99.7%', label: '用户满意度' },
                  { value: '300+', label: '合作媒体' },
                ].map((stat, i) => (
                  <div key={i}>
                    <p className="text-3xl md:text-4xl font-extrabold text-background-50 mb-2 font-heading">
                      {stat.value}
                    </p>
                    <p className="text-sm text-background-50/80">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="w-full max-w-5xl mx-auto px-4 md:px-6 py-14 md:py-20">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center font-heading">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <span className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                    <i className="ri-mail-line text-primary-600 text-xl"></i>
                  </span>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-1 font-heading">
                      电子邮箱
                    </h3>
                    <p className="text-sm text-foreground-600">contact@heiliao.com</p>
                    <p className="text-xs text-foreground-500 mt-1">一般咨询与合作请发送至此邮箱</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                    <i className="ri-customer-service-line text-primary-600 text-xl"></i>
                  </span>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-1 font-heading">
                      在线客服
                    </h3>
                    <p className="text-sm text-foreground-600">工作日 9:00 - 18:00</p>
                    <p className="text-xs text-foreground-500 mt-1">通过右下角在线客服入口联系我们</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                    <i className="ri-error-warning-line text-primary-600 text-xl"></i>
                  </span>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-1 font-heading">
                      侵权投诉
                    </h3>
                    <p className="text-sm text-foreground-600">report@heiliao.com</p>
                    <p className="text-xs text-foreground-500 mt-1">如发现侵权内容，请发送相关证明材料</p>
                  </div>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden h-[300px] bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20office%20reception%20desk%20with%20friendly%20staff%2C%20warm%20inviting%20atmosphere%2C%20professional%20customer%20service%20setting%2C%20dark%20red%20and%20neutral%20branding%20elements&width=800&height=600&seq=about-contact&orientation=landscape"
                  alt="联系我们"
                  title="黑料大全 - 联系我们"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}